import pad from "../number/pad"

export default (date: Date): string => `${ date.getFullYear() }-${ pad(2, date.getMonth() + 1) }-${ pad(2, date.getDate()) }`
